import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';

import { Slideshow } from '../models/slideshow';
import { News } from '../models/news';

@Injectable({
  providedIn: 'root'
})

export class NewsUploadService extends CrudService<News, number> {

  constructor(protected _http: HttpClient) {
    super(_http, `${environment.baseUrl}/news`);
  }

  
}



